import styled from 'styled-components';

export const Skeleton = styled.div<{
	width: string;
	height: string;
	borderRadius: string;
}>`
	@keyframes loading {
		0% {
			/* transform: translateX(0); */
			left: 0px;
		}
		100% {
			/* transform: translateX(
				${({ width }) => {
				if (width.includes('px')) {
					return `${parseInt(width.split('px')[0], 10) * 2}px`;
				}
				if (width.includes('%')) {
					return '100%';
				}
				return `${parseInt(width, 10) * 2}px`;
			}}
			); */
			left: 100%;
		}
	}

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 30px;
		height: 100%;
		background: linear-gradient(to right, #f2f2f2, #ddd, #f2f2f2);
		animation: loading 1s infinite linear;
		animation-play-state: running;
	}

	width: ${({ width }) => width};
	height: ${({ height }) => height};
	position: relative;
	overflow-x: hidden;
	background-color: #f2f2f2;

	border-radius: ${({ borderRadius }) => borderRadius};
`;
